import { render, staticRenderFns } from "./IconFooterMobile.vue?vue&type=template&id=b8b7c572&"
import script from "./IconFooterMobile.vue?vue&type=script&lang=js&"
export * from "./IconFooterMobile.vue?vue&type=script&lang=js&"
import style0 from "./IconFooterMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports